/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListCalendarsQueryResponse,
  ListCalendarsPathParams,
} from '../types/ListCalendars'

function getListCalendarsUrl({
  integration_id,
}: {
  integration_id: ListCalendarsPathParams['integration_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/calendar-integration/${integration_id}/calendars/` as const,
  }
  return res
}

/**
 * @description List all calendars for the given integration.
 * @summary List calendars for a calendar integration
 * {@link /api/v1/calendar-integration/:integration_id/calendars/}
 */
export async function listCalendars(
  {
    integration_id,
  }: { integration_id: ListCalendarsPathParams['integration_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListCalendarsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListCalendarsUrl({ integration_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
